export default {
      id: "2-2-0-usage",
      viewBox: "0 0 180 180",
      url: "assets/" + "sprite.svg#2-2-0-usage",
      toString: function () {
        return this.url;
      }
    }